import React from 'react';

const SectionTitle = React.memo(({ children, icon }) => (
    <h2 className="text-xl font-semibold text-sky-700 mb-4 mt-8 border-b border-sky-200 pb-2 flex items-center">
        {icon && React.createElement(icon, { className: "h-6 w-6 mr-2 text-sky-600" })}
        {children}
    </h2>
));

export default SectionTitle;